import { useEffect, useState } from 'react';
import { winnerCards } from '../../data/winners';

const moreProjects = winnerCards
  .filter((winner) => winner.id !== 'winner-2000')
  .filter((winner) => {
    const media = winner.media.toLowerCase();
    return media.includes('sculpture');
  })
  .slice(0, 4);

export default function JyungMeePark() {
  const slides = [
    { src: '/uploads/jyungmee_park_862x1280.jpg', alt: 'Jyung Mee Park work 1' },
    { src: '/uploads/Jyung-Mee-Park-1.jpg', alt: 'Jyung Mee Park work 2' },
    { src: '/uploads/Jung-Mee-Park-2.jpg', alt: 'Jyung Mee Park work 3' },
  ];
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) {
      return undefined;
    }

    const intervalId = window.setInterval(() => {
      setActiveSlide((currentSlide) => (currentSlide + 1) % slides.length);
    }, 3500);

    return () => window.clearInterval(intervalId);
  }, [slides.length]);

  return (
    <section className="portfolio-item-page">
      <div className="mx-auto max-w-7xl px-5 py-10 md:px-8">
        <h1 className="subheading uppercase">Jyung Mee Park</h1>

        <div className="portfolio-item-intro">
          <div className="portfolio-item-gallery">
            <div className="portfolio-item-slideshow">
              <div className="portfolio-item-slideshow-frame" aria-label="Jyung Mee Park slideshow">
                {slides.map((slide, index) => (
                  <img
                    key={slide.src}
                    className={`portfolio-item-slide ${index === activeSlide ? 'portfolio-item-slide-active' : ''}`}
                    src={slide.src}
                    alt={slide.alt}
                    aria-hidden={index !== activeSlide}
                  />
                ))}
              </div>
              <div className="portfolio-item-slideshow-dots" aria-label="Slideshow progress">
                {slides.map((slide, index) => (
                  <button
                    key={slide.src}
                    type="button"
                    className={`portfolio-item-dot ${index === activeSlide ? 'portfolio-item-dot-active' : ''}`}
                    onClick={() => setActiveSlide(index)}
                    aria-label={`Show slide ${index + 1}`}
                    aria-pressed={index === activeSlide}
                  />
                ))}
              </div>
            </div>
          </div>

          <div className="portfolio-item-description">
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1.25rem', padding: '0 0' }}>2000</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '2rem 0 0', fontWeight: '700'}}>Juror's Statement</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '0 0' }}>The Korean Arts Foundation of America has announced the winners of its eighth awards. Artist Jyung Mee Park was selected by a panel of three jurors and will receive a prize of $10,000 as well as an exhibition of her work.</p>
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '0 0' }}>Park’s large-scale, abstract sculptures made from thousands of sheets of folded rice paper have been exhibited in solo shows at 55 Mercer Gallery, New York, Corcoran Gallery of Art, Washington, D.C. and most recently, in the Special Projects Program at P.S.1 Contemporary Art Center in New York.</p>
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '0 0' }}>Hunter Drohojowska-Philp says, “Park brings together the aesthetics of the East and West by combining monumental scale with the fragility of paper. Inspired by the shapes of Buddhist Korean lanterns and the blossoming of flowers and plants, she folds and layers paper into giant cones, vessels, and towers.” Park, who is 35, came to this country at the age of 18. Initially trained as a painter, she started doing this work while bed-ridden for a year with an illness. She began folding the paper as a form of medication, saying, “Busy hands-free up your mind.”</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Jurors</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Jay Belloli, Director, Armory Center for the Arts</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Julie Lazar, formerly Director of Experimental Programs at the Museum of Contemporary Art</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '2', fontSize: '1rem', padding: '0 0' }}>Hunter Drohojowska-Philp, independent art writer for the L.A. Times and Artnews</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', padding: '3rem 0 0', fontWeight: '700' }}>Biography</p>

            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>Jyung Mee Park was born in Korea and did her undergraduate studies at Parsons School of Design, New York, NY and got her masters degree from the Rhode Island School of Design in Providence, RI. She taught full time at MICA from 1994-2006 and left to teach at Korea National University of Arts, Samsung Art and Design Institute and at Ewha Women’s University in Seoul, Korea. In 2011, she has returned to teach at MICA again in the foundation department.</p>
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>She has had numerous solo and group shows and has exhibited her work at such venues as the Corcoran Gallery of Art, Washington, D.C.; MOMA, P.S.1 Contemporary Art Center, Queens,NY; Arizona State University Museum of Art, AZ; Aldrich Museum of Art, Ridgefield, CT; Museum of Art, Seoul National University,Seoul, Korea; Delaware Museum of Art, Wilmington, DE; Kiang Gallery, Atlanta, GA; Suyama Space, Seattle WA.</p>
            <p className="general-text-third" style={{ textAlign: 'left', maxWidth: 'none', marginTop: 0, color: 'var(--purple-dark)', lineHeight: '1.6', fontSize: '1rem', paddingBottom: '2rem' }}>She is the recipient of 2 Maryland State Art Council grants in new genre and sculpture. She was also awarded Grants from the Creative Capital Foundation, Pollack Krasner Foundation and the Korea Arts Foundation of America. She was a resident artist at BEMIS Center for Contemporary Art, Omaha, NE and in Grand Arts, Kansas City, MO. Her work is in the collection of Arizona State University Art Museum, Tempe, AZ; The Korea Times Headquarters, Los Angeles, CA; Southwest Bell Communications, Dallas, TX; Alston & Bird, Atlanta, GA; King & Spaulding, Atlanta, GA.</p>

            {/* <a href='placeholder' className='nav-link'>Artist's Website</a> */}
          </div>
        </div>
      </div>

      <section className="portfolio-item-more-projects w-full" aria-labelledby="more-projects-heading">
        <div className="mx-auto max-w-7xl px-5 md:px-8">
          <h2 className="subheading" id="more-projects-heading" style={{ marginBottom: '1.5rem' }}>
            More projects
          </h2>
        </div>

        <div className="winners-grid portfolio-item-more-grid">
          {moreProjects.map((winner) => (
            <a
              key={winner.id}
              href={winner.href}
              className="winner-card"
              aria-label={`${winner.year} ${winner.media} by ${winner.name}`}
            >
              <img className="winner-card-image" src={winner.image} alt="" />
              <div className="winner-card-overlay">
                <div className="winner-card-portrait-wrap">
                  <img className="winner-card-portrait" src={winner.portrait} alt="" />
                </div>
                <div className="winner-card-copy">
                  <span className="winner-card-meta">
                    {winner.year} | {winner.media}
                  </span>
                  <span className="winner-card-name">{winner.name}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>
    </section>
  );
}
